// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatLimitNotice-modulecontact__jvvUK";
var _2 = "GretaAIChatLimitNotice-modulenotice__U4wMw";
export { _1 as "contact", _2 as "notice" }
